<!--sidebar-->
<c-sidebar
    #sidebar1="cSidebar"
    class="d-print-none sidebar sidebar-fixed sidebar-dark border-end"
    colorScheme="dark"
    id="sidebar1"
    visible
>
    <c-sidebar-header>
        <c-sidebar-brand [routerLink]="[]">
        <a href="/#/dashboard" class="text-decoration-none sidebar-brand-row">
            <span class="sidebar-brand-text">ProcureX</span>
        </a>
        </c-sidebar-brand>
    </c-sidebar-header>

    <ng-scrollbar
        #scrollbar="ngScrollbar"
        (updated)="onScrollbarUpdate(scrollbar.state)"
        class="overflow sidebar-scroll"
        pointerEventsMethod="scrollbar"
        visibility="hover"
    >
        <c-sidebar-nav
            #overflow
            [navItems]="navItems"
            (click)="onMenuItemClick($event)"
            dropdownMode="close"
            compact
        />
    </ng-scrollbar>

    <div class="sidebar-session">
        <div class="sidebar-session-label">{{ 'sidebar.session'|translate }}</div>
        <div class="sidebar-session-row">
            <div class="sidebar-session-user">
                <a routerLink="/profile" class="sidebar-session-avatar" aria-label="View profile" title="View profile">{{ userInitials }}</a>
                <div class="sidebar-session-text">
                <div class="sidebar-session-name">{{ userName }}</div>
                <div class="sidebar-session-role">{{ userRoleLabel }}</div>
                </div>
            </div>
            <button
                type="button"
                class="sidebar-logout-btn"
                (click)="logout()"
                aria-label="Log out"
                title="Log out"
            >
                <svg cIcon name="cil-account-logout" size="lg"></svg>
            </button>
        </div>
    </div>
</c-sidebar>

<!--main-->
<div class="wrapper d-flex flex-column min-vh-100">
    <!--app-header-->
    <app-default-header
        [cShadowOnScroll]="'sm'"
        class="mb-4 d-print-none header header-sticky p-0 shadow-sm"
        position="sticky"
        sidebarId="sidebar1"
        (languageChangedEvent)="languageChangedEvent($event)"
    />
    <!--app-body-->
    <div class="body flex-grow-1" style="margin-bottom:50px!important">
        <div class="container-fluid px-4">
        <router-outlet />
        </div>
    </div>
    <!--app footer-->
    <!-- <app-default-footer /> -->
</div>